module.exports = __webpack_public_path__ + "img/pointcloud.34c82466.png";